import { 
  AddToCartParams,
  InitiateCheckoutParams,
  PurchaseParams,
  ViewContentParams
} from '../types/metaPixel';

export const init = (pixelId: string) => {
  if (window.fbq?.queue) {
    const isInitialized = window.fbq.queue.some(
      (item: unknown[]) => item[0] === 'init' && item[1] === pixelId
    );
    if (isInitialized) {
      return;
    }
  }
  window.fbq('init', pixelId);
};

export const trackPageView = () => {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', 'PageView');
};

export const trackViewContent = (params: ViewContentParams) => {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', 'ViewContent', params);
};

export const trackAddToCart = (params: AddToCartParams) => {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', 'AddToCart', params);
};

export const trackInitiateCheckout = (params: InitiateCheckoutParams) => {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', 'InitiateCheckout', params);
}

export const trackPurchase = (params: PurchaseParams) => {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', 'Purchase', params);
};

export const isPixelIdValid = (pixelId?: string | null): boolean => {
  return !!(pixelId && /^\d{15,16}$/.test(pixelId));
}; 